import { Box, Button, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { deleteUser } from "../../../services/user-service";
import { modalStyle } from "../../../utils/modal-style";

export default function DeleteUserModal({ id, open, setOpen }) {
  const accessToken = localStorage.getItem("token");
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      await deleteUser(accessToken, id);

      alert("Usuário deletado com sucesso.");
      navigate("/cadastro/usuarios");
      setOpen(false);
      window.location.reload(true);
    } catch (error) {
      alert("Algo deu errado.");
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="box-container" sx={modalStyle}>
        <p>{`Tem certeza que deseja excluir o usuário ${id}?`}</p>
        <div className="buttons-container">
          <Button onClick={handleDelete} variant="contained">
            Sim
          </Button>
          <Button onClick={handleClose} variant="outlined">
            Não
          </Button>
        </div>
      </Box>
    </Modal>
  );
}
